import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "reactstrap";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Collapse from "@mui/material/Collapse";
import { makeStyles } from "@mui/styles";
import BackButton from "../../components/BackButton/BackButton";
import {
	Grid,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Accordion,
	AccordionSummary,
	AccordionDetails
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
//resetViewTransactionDetails, getViewTransactionDetails
import {
	resetViewTransactionDetails,
	getViewTransactionDetails
} from "../../redux/actions/viewTransactionDetailsAction";

import { ExpandMore } from "@mui/icons-material";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useRowStyles = makeStyles({
	root: {
		"& > *": {
			// borderBottom: "unset",
		}
	}
});

const GetWayTransactionDetails = () => {
	const location = useLocation();

	const customerId = location.state.param1;
	// console.log(customerId);
	const userId = location.state.param2;
	// console.log(userId);
	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [viewTransactionDetailsResArray, setViewTransactionDetailResArray] =
		useState([]);

	const viewTransactionDetailsRes = useSelector(
		({ viewTransactionDetails }) => viewTransactionDetails
	);
	const classes = useRowStyles();

	// console.log(viewTransactionDetailsRes);

	// console.log("viewTransactionDetailsRes");

	const getGateWayTransactionFunc = () => {
		const getGateWayTransactionReq = {
			walletTransactionMasterDetailsRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				transactionId: customerId,
				walletCustomerId: userId
			}
		};

		return dispatch(
			getViewTransactionDetails(
				getGateWayTransactionReq,
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getGateWayTransactionFunc();
		}
	}, [customerId, regenerateTokenRes.data.status]);

	const viewTransactionDetailsResFunc = () => {
		if (viewTransactionDetailsRes.data.status == "success") {
			setViewTransactionDetailResArray(
				viewTransactionDetailsRes.data.transactionMasterDetailsResponseVO
			);
		}
		if (viewTransactionDetailsRes.data.status == "Failed") {
			setViewTransactionDetailResArray(viewTransactionDetailsRes.data);
			if (
				viewTransactionDetailsRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				viewTransactionDetailsRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
	};

	useEffect(() => {
		viewTransactionDetailsResFunc();
	}, [viewTransactionDetailsRes.data.status]);

	return (
		<>
			<Layout>
				<BackButton />
				<div
					style={{
						background: "white",
						paddingTop: "0.5rem",
						paddingBottom: "1rem"
					}}
				>
					<Box marginLeft={3} marginRight={3} paddingBottom={2}>
						{/* <BackButton /> */}
						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">
										Customer Details
									</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<TableContainer
										component={Paper}
										style={{
											marginBottom: "30px"
										}}
									>
										{viewTransactionDetailsRes.data
											.transactionMasterDetailsResponseVO &&
											viewTransactionDetailsRes.data
												.transactionMasterDetailsResponseVO ? (
											<>
												<Table
													className={classes.table}
													aria-label="a dense table"
													style={{ whiteSpace: "nowrap" }}
												>
													<TableHead>
														<TableRow className="tableHeaderColor">
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Customer Id{" "}
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Customer Name
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Country Code
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Customer Email
															</TableCell>
														</TableRow>
													</TableHead>
													{viewTransactionDetailsResArray && (
														<TableBody>
															{viewTransactionDetailsResArray &&
																[]
																	.concat(viewTransactionDetailsResArray)
																	.map((row, index) => (
																		<TableRow key={index}>
																			<TableCell align="center">
																				{row.toCustomerId
																					? row.toCustomerId
																					: "-"}
																			</TableCell>
																			<TableCell align="center">
																				{row.fromCustomerName
																					? row.fromCustomerName
																					: "-"}
																			</TableCell>
																			<TableCell align="center">
																				{row.manualCode ? row.manualCode : "-"}
																			</TableCell>
																			<TableCell align="center">
																				{row.custEmail ? row.custEmail : "-"}
																			</TableCell>
																		</TableRow>
																	))}
														</TableBody>
													)}
												</Table>
											</>
										) : (
											""
										)}
									</TableContainer>
								</AccordionDetails>
							</Accordion>
						</div>

						{/* <TableContainer
          component={Paper}
          style={{
            marginBottom: "30px",
          }}
        >
          <BackButton />

          {viewTransactionDetailsRes.data.transactionMasterDetailsResponseVO &&
            viewTransactionDetailsRes.data.transactionMasterDetailsResponseVO ?
            (
              <>
                <Typography
                  variant="body1"
                  style={{
                    textAlign: "center",
                    margin: "10px 0",
                    color: "#01367e",
                    fontSize: "1.4rem",
                  }}
                >
                  Customer Details
                </Typography>

                <Table
                  className={classes.table}
                  aria-label="a dense table"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <TableHead>
                    <TableRow style={{ background: "#00b9f5" }}>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Customer Id </TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Customer Name</TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Country Code</TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Customer Email</TableCell>
                    </TableRow>
                  </TableHead>
                  {viewTransactionDetailsResArray && (
                    <TableBody>
                      {viewTransactionDetailsResArray &&
                        []
                          .concat(viewTransactionDetailsResArray)
                          .map((row, index) => (
                            <TableRow key={index}>
                              <TableCell align="center">{row.toCustomerId}</TableCell>
                              <TableCell align="center">
                                {row.fromCustomerName}
                              </TableCell>
                              <TableCell align="center">{row.manualCode}</TableCell>
                              <TableCell align="center">{row.custEmail}</TableCell>
                            </TableRow>
                          ))}
                    </TableBody>
                  )}
                </Table>
              </>
            ) : (
              // <h1 style={{ textAlign: "center" }}>No Data Found</h1>
              ""
            )
          }
        </TableContainer> */}

						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">
										Transaction Details
									</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<TableContainer
										component={Paper}
										style={{
											marginBottom: "30px"
										}}
									>
										{viewTransactionDetailsRes.data
											.transactionMasterDetailsResponseVO &&
											viewTransactionDetailsRes.data
												.transactionMasterDetailsResponseVO ? (
											<>
												{viewTransactionDetailsResArray && (
													<Table
														className={classes.table}
														aria-label="a dense table"
														style={{ whiteSpace: "nowrap" }}
													>
														<TableHead>
															<TableRow className="tableHeaderColor">
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Tracking Id{" "}
																</TableCell>
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Payment Id
																</TableCell>
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Purchase Amount
																</TableCell>
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Currency
																</TableCell>
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Status
																</TableCell>
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Date
																</TableCell>
															</TableRow>
														</TableHead>

														<TableBody>
															{viewTransactionDetailsResArray &&
																[]
																	.concat(viewTransactionDetailsResArray)
																	.map((row, index) => (
																		<TableRow key={index}>
																			<TableCell align="center">
																				{row.transactionId
																					? row.transactionId
																					: "-"}
																			</TableCell>
																			<TableCell align="center">
																				{row.paymentId ? row.paymentId : "-"}
																			</TableCell>
																			<TableCell align="center">
																				{row.transactionAmount
																					? row.transactionAmount
																					: "-"}
																			</TableCell>
																			<TableCell align="center">
																				{row.currency ? row.currency : "-"}
																			</TableCell>
																			<TableCell align="center">
																				{row.transactionStatus
																					? row.transactionStatus
																					: "-"}
																			</TableCell>
																			<TableCell align="center">
																				{row.timestamp ? row.timestamp : "-"}
																			</TableCell>
																		</TableRow>
																	))}
														</TableBody>
													</Table>
												)}
											</>
										) : (
											""
										)}
									</TableContainer>
								</AccordionDetails>
							</Accordion>
						</div>

						{/* <TableContainer
              component={Paper}
              style={{
                marginBottom: "30px",
              }}
            >
              {
                viewTransactionDetailsRes.data.transactionMasterDetailsResponseVO &&
                  viewTransactionDetailsRes.data.transactionMasterDetailsResponseVO ?
                  (<>
                    <Typography
                      variant="body1"
                      style={{
                        textAlign: "center",
                        margin: "10px 0",
                        color: "#01367e",
                        fontSize: "1.4rem",
                      }}
                    >
                      Transaction Details
                    </Typography>

                    {viewTransactionDetailsResArray && (
                      <Table
                        className={classes.table}
                        aria-label="a dense table"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <TableHead>
                          <TableRow style={{ background: "#00b9f5" }}>
                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Tracking Id </TableCell>
                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Payment Id</TableCell>
                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Purchase Amount</TableCell>
                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Currency</TableCell>
                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Status</TableCell>
                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Date</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {viewTransactionDetailsResArray &&
                            []
                              .concat(viewTransactionDetailsResArray)
                              .map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell align="center">
                                    {row.transactionId}
                                  </TableCell>
                                  <TableCell align="center">{row.paymentId}</TableCell>
                                  <TableCell align="center">
                                    {row.transactionAmount}
                                  </TableCell>
                                  <TableCell align="center">{row.currency}</TableCell>
                                  <TableCell align="center">
                                    {row.transactionStatus}
                                  </TableCell>
                                  <TableCell align="center">{row.timestamp}</TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    )}
                  </>)
                  :
                  (
                    ""
                  )
              }

            </TableContainer> */}

						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">Bin Details</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<TableContainer
										component={Paper}
										style={{
											marginBottom: "30px"
										}}
									>
										{viewTransactionDetailsRes.data
											.transactionMasterDetailsResponseVO &&
											viewTransactionDetailsRes.data
												.transactionMasterDetailsResponseVO ? (
											<>
												{viewTransactionDetailsResArray && (
													<Table
														className={classes.table}
														aria-label="a dense table"
														style={{ whiteSpace: "nowrap" }}
													>
														<TableHead>
															<TableRow className="tableHeaderColor">
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	First Six{" "}
																</TableCell>
																<TableCell
																	align="center"
																	style={{ fontWeight: "bold", color: "white" }}
																>
																	Last Four
																</TableCell>
															</TableRow>
														</TableHead>

														<TableBody>
															{viewTransactionDetailsResArray &&
																[]
																	.concat(viewTransactionDetailsResArray)
																	.map((row, index) => (
																		<TableRow key={index}>
																			<TableCell align="center">
																				{row.firstSix ? row.firstSix : "-"}
																			</TableCell>
																			<TableCell align="center">
																				{row.lastFour ? row.lastFour : "-"}
																			</TableCell>
																		</TableRow>
																	))}
														</TableBody>
													</Table>
												)}
											</>
										) : (
											""
										)}
									</TableContainer>
								</AccordionDetails>
							</Accordion>
						</div>

						{/* <TableContainer
              component={Paper}
              style={{
                marginBottom: "30px",
              }}
            >
              {
                viewTransactionDetailsRes.data.transactionMasterDetailsResponseVO &&
                  viewTransactionDetailsRes.data.transactionMasterDetailsResponseVO ?
                  (<>
                    <Typography
                      variant="body1"
                      style={{
                        textAlign: "center",
                        margin: "10px 0",
                        color: "#01367e",
                        fontSize: "1.4rem",
                      }}
                    >
                      Bin Details
                    </Typography>

                    {viewTransactionDetailsResArray && (
                      <Table
                        className={classes.table}
                        aria-label="a dense table"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <TableHead>
                          <TableRow style={{ background: "#00b9f5" }}>
                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>First Six </TableCell>
                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Last Four</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {viewTransactionDetailsResArray &&
                            []
                              .concat(viewTransactionDetailsResArray)
                              .map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell align="center">{row.firstSix}</TableCell>
                                  <TableCell align="center">{row.lastFour}</TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    )}
                  </>)
                  :
                  (
                    ""
                  )
              }

            </TableContainer> */}

						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">History</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<TableContainer component={Paper}>
										{viewTransactionDetailsResArray && (
											<Table
												className={classes.table}
												aria-label="a dense table"
												style={{ whiteSpace: "nowrap" }}
											>
												<TableHead>
													<TableRow className="tableHeaderColor">
														<TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															Action{" "}
														</TableCell>
														<TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															TimeStamp
														</TableCell>
														<TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															Transactionn Type
														</TableCell>
														<TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															Purchase Amount
														</TableCell>
														<TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															{" "}
															Currency
														</TableCell>
														<TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															{" "}
															Remark
														</TableCell>
													</TableRow>
												</TableHead>

												<TableBody>
													{viewTransactionDetailsResArray.transactionHistoryVOList &&
														[]
															.concat(
																viewTransactionDetailsResArray.transactionHistoryVOList
															)
															.map((row, index) => (
																<TableRow key={index}>
																	<TableCell align="center">-</TableCell>
																	<TableCell align="center">
																		{row.timestamp ? row.timestamp : "-"}
																	</TableCell>
																	<TableCell align="center">
																		{row.transactionType
																			? row.transactionType
																			: "-"}
																	</TableCell>
																	<TableCell align="center">
																		{row.amount ? row.amount : "-"}
																	</TableCell>
																	<TableCell align="center">
																		{row.currency ? row.currency : "-"}
																	</TableCell>
																	<TableCell align="center">
																		{row.remark ? row.remark : "-"}
																	</TableCell>
																</TableRow>
															))}
												</TableBody>
											</Table>
										)}
									</TableContainer>
								</AccordionDetails>
							</Accordion>
						</div>

						{/* <TableContainer component={Paper}>
              <Typography
                variant="body1"
                style={{
                  textAlign: "center",
                  margin: "10px 0",
                  color: "#01367e",
                  fontSize: "1.4rem",
                }}
              >
                History
              </Typography>

              {viewTransactionDetailsResArray && (
                <Table
                  className={classes.table}
                  aria-label="a dense table"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <TableHead>
                    <TableRow style={{ background: "#00b9f5" }}>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Action </TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>TimeStamp</TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Transactionn Type</TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Purchase Amount</TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}> Currency</TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}> Remark</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {viewTransactionDetailsResArray.transactionHistoryVOList &&
                      []
                        .concat(
                          viewTransactionDetailsResArray.transactionHistoryVOList
                        )
                        .map((row, index) => (
                          <TableRow key={index}>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center">{row.timestamp}</TableCell>
                            <TableCell align="center">
                              {row.transactionType}
                            </TableCell>
                            <TableCell align="center">{row.amount}</TableCell>
                            <TableCell align="center">{row.currency}</TableCell>
                            <TableCell align="center">{row.remark}</TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              )}
            </TableContainer> */}
					</Box>
				</div>
			</Layout>
		</>
	);
};

export default GetWayTransactionDetails;
